import { computed, ref, watch } from 'vue';
import { defineStore, acceptHMRUpdate } from 'pinia';
import useMemberMeta from '@dashboardApp/composables/useMemberMeta';
import { useUserStore } from '@dashboardApp/stores/UserStore';

export const useDirectoryOnboardingStore = defineStore('DirectoryOnboardingStore', () => {

    const userStore = useUserStore();
    const { getMeta, saveMeta } = useMemberMeta();

    const checklist = ref([
        {
            title: 'Complete account set up',
            description: '',
            metaKey: 'directory_account_setup',
            metaValue: 'complete', // The expected value to consider step as complete,
            complete: true // Assume true before navigation on dashboard
        },
        {
            title: 'Search for products',
            description: '<a href="" class="sh-text-black">Search the SaleHoo Directory</a> by keyword or by exploring our categories.',
            metaKey: 'directory_onboarding_searched_products',
            metaValue: 1,
            complete: false
        },
        {
            title: 'Contact your first supplier',
            description: 'Get in touch with one of our thousands of trusted suppliers.',
            metaKey: 'directory_onboarding_contacted_supplier',
            metaValue: 1,
            complete: false
        },
    ]);

    const isChecklistCompleted = computed(() => {
        for (const [, item] of Object.entries(checklist.value)) {
            if (!item.complete) {
                return false;
            }
        }
        return true;
    });
    const checklistStepsCount = computed(() => checklist.value.length);
    const completedChecklistCount = computed(() => {
        let count = 0;
        for (const [, item] of Object.entries(checklist.value)) {
            if (item.complete) {
                count++;
            }
        }
        
        return count;
    });

    function saveStep(metaKey, metaValue = 1) {
        if (getMeta(metaKey)) {
            return;
        }
        saveMeta(metaKey, metaValue, true);
    }

    // Watch specific meta keys (instead of all) to improve performance
    watch(
        () => userStore.user.meta.directory_onboarding_searched_products ,
        () => {
            const item = checklist.value[1];
            checklist.value[1]['complete'] = !item.complete ? getMeta(item.metaKey) == item.metaValue : true;
        },
        { immediate: true }
    );
    watch(
        () => userStore.user.meta.directory_onboarding_contacted_supplier ,
        () => {
            const item = checklist.value[2];
            checklist.value[2]['complete'] = !item.complete ? getMeta(item.metaKey) == item.metaValue : true;
        },
        { immediate: true }
    );

    return {
        checklist,
        isChecklistCompleted,
        checklistStepsCount,
        completedChecklistCount,
        saveStep,
    }
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useDirectoryOnboardingStore, import.meta.hot));
}